import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';

/* this is to get clicked element position on window which helps to land onto same position when navidated back
if there is no pageYOffset it will return defaultOffsetValue */
export const getScrolledElementOffSet = (defaultOffsetValue = 1000) => {
    if (!__SERVER__) {
        return window.pageYOffset;
    }
    return defaultOffsetValue;
};

/* This is to store scrolled element PPID and its position when navigated from PLP/SRP to PDP */
export const setDefaultOffSet = (ppId, setdatato, defaultOffsetValue) => {
    if (!__SERVER__) {
        const topOfElement = getScrolledElementOffSet(defaultOffsetValue);
        const scrollKeyVal = {
            galleryScrollTo: ppId,
            galleryScrollToOffSet: topOfElement,
        };
        const scrollKey = { key: window.location.href, val: scrollKeyVal };
        LocalStorage.setData(setdatato, scrollKey, true, '', false);
    }
};

/* This is to get given localstorage value as key value pair if it stored as object */
export const getDefaultOffSet = (getdatafrom, isKeyExists = true) => {
    if (isKeyExists) {
        const galleryScrollToOffsetVal = LocalStorage.getData(getdatafrom, true);
        const parsedJson = galleryScrollToOffsetVal && JSON.parse(galleryScrollToOffsetVal);
        const galleryScrollToVal =
            parsedJson?.val && parsedJson.key === window.location.href ? parsedJson.val : {};
        return galleryScrollToVal;
    }
    return LocalStorage.getData(getdatafrom);
};
